<template>
    <section class="hero is-hero-bar">
        <div :class="[$style.adjustPaddings, 'hero-body']">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <h1 class="title hero-title">
                            <slot/>
                        </h1>
                    </div>
                </div>
                <div v-show="hasRightVisible" class="level-right">
                    <div class="level-item">
                        <slot name="right"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
    import { Vue, Prop } from 'vue-property-decorator';

    export default class HeroBar extends Vue {
        @Prop({ type: Boolean, required: false, default: true })
        public hasRightVisible: boolean = true;
    }
</script>

<style lang="scss" module>
    .adjustPaddings {
        padding-left: 0px;
        padding-right: 0px;
    }
</style>
